let CoinMatchConfig = require("activity/CoinMatchActivity/CoinMatchConfig")
let CoinMatchLogic = require("activity/CoinMatchActivity/CoinMatchLogic")
let CoinMatchManager = require("activity/CoinMatchActivity/CoinMatchManager")
let CoinMatchConst = require("activity/CoinMatchActivity/CoinMatchConst")

const InviteRewardStatus = CoinMatchConst.InviteRewardStatus

let CoinMatchInvitePanel = xClass("CoinMatchInvitePanel", BasePanel, () => {
    return cc.CSLoader.createNode(CoinMatchConfig.moreStep.csb);
})

CoinMatchInvitePanel.preloadResPromise = function(withMask = false) {
    if (CoinMatchConfig.moreStep.resList.length > 0) {
        return preloadWithLoadingPromise(CoinMatchConfig.moreStep.resList, withMask);
    } else {
        return Promise.resolve();
    }
}

CoinMatchInvitePanel.prototype.ctor = function () {
    var self = this;
    BasePanel.prototype.ctor.call(self);
    self.popup(true, null, handler(self, self.buildInviteInfo));
}

CoinMatchInvitePanel.prototype.onEnter = function() {    
    BasePanel.prototype.onEnter.call(this);
    this.initUI();

    this.handler = CoinMatchManager.getInstance().on(CoinMatchManager.EventEnum.kStepChanged, ()=> this.updateStep())[1];
}

CoinMatchInvitePanel.prototype.initUI = function() {
    let layout = CoinMatchConfig.moreStep;
    let manager = CoinMatchManager.getInstance();

    this.closeBtn = GetChildByPath(this, layout.btnClose);
    quickBuildBtn(this.closeBtn, UIButton, PushBounceAnim, ()=> this.onClose(), true);
    
    this.inviteBtn = GetChildByPath(this, layout.btnInvite);
    quickBuildBtn(this.inviteBtn, UIButton, PushBounceAnim, ()=> this.onShareInvite(), true);

    this.adBtn = GetChildByPath(this, layout.btnAd);
    quickBuildBtn(this.adBtn, UIGroupButton, PushBounceAnim, ()=> this.onClickAd(), true);
    let lb = GetChildByPath(this.adBtn, layout.btnAdLb);
    lb.setString(CoinMatchConfig.values.adStep);
    lb = GetChildByPath(this, layout.tipAd);
    lb.setString(CoinMatchConfig.strings.adTip);
    this.adBtn.ttAddBtnFlag(1, cc.p(3, -7))
    this.updateAdBtn();

    // if (DYAdUtil.isOpen()){
    //     DYAdUtil.modifyBtnSize(this.adBtn,cc.size(280,120))
    //     DYAdUtil.modifyBtnSize(this.inviteBtn,cc.size(280,120))
    //     //  -82 22
    //     this.inviteBtn.getChildByName("label").setPosition(cc.p(-55,18))
    //     // 181 449
    //     this.inviteBtn.x = 429
    //     this.adBtn.x = 161

    // }

    let gainLbs = [];
    this.lbExtraStep = null;
    let isBold = layout.tipGainBold;
    layout.tipGain.forEach((v)=> {
        let lb = GetChildByPath(this, v.path);
        if (v.key != null) 
            lb.setString(getText(v.key));
        else {
            this.lbExtraStep = lb;
            this.lbExtraStep.setString(manager.getExtraSteps());
        }
        if (isBold)
            lb.getVirtualRenderer()._setFontWeight('bold');
        gainLbs.push(lb);        
        lb.setContentSize(CalculateLbTTFSize(lb));
        lb.setAnchorPoint(0, 0.5);
    });
    this.gainLbs = gainLbs; 
    let gainBg = GetChildByPath(this, layout.tipGainPin);
    this.tipGainCenter = {x: gainBg.x + gainBg.getContentSize().width / 2, y: gainBg.y - gainBg.getContentSize().height / 2};
    HorizontalNodeGroup(this.gainLbs, this.tipGainCenter);

    let inviteLbs = [];
    layout.tipInvite.forEach((v)=> {
        let lb = GetChildByPath(this, v.path);
        if (v.key != null)
            lb.setString(getText(v.key));
        else 
            lb.setString(manager.getDefaultInviteStep());        
        lb.setContentSize(CalculateLbTTFSize(lb));
        lb.setAnchorPoint(0, 0.5);
        inviteLbs.push(lb);
    });
    HorizontalNodeGroup(inviteLbs, layout.tipInviteCenter);
    
    DCAssist.dc4ShareShow("CoinMatchAskHelp")
    // this.buildInviteInfo()
}

CoinMatchInvitePanel.prototype.updateStep = function() {
    this.lbExtraStep.setString(CoinMatchManager.getInstance().getExtraSteps());    
    this.lbExtraStep.setContentSize(CalculateLbTTFSize(this.lbExtraStep));
    HorizontalNodeGroup(this.gainLbs, this.tipGainCenter);
}

CoinMatchInvitePanel.prototype.updateAdBtn = function() {
    let adStep = CoinMatchManager.getInstance().getMoreStepsNum();
    if (adStep >= CoinMatchConfig.values.adLimit)
        this.adBtn.setEnabled(false);
    else    
        this.adBtn.setEnabled(true);
}

CoinMatchInvitePanel.prototype.onClickAd = function() {
    // DYAdUtil.showAdSecondConfirmPanel(()=>{
        DCAssist.dc4AdClick("battleForGold", "ad_add_step_btn_click");
        CoinMatchLogic.adForMoreStep(
            CoinMatchConst.AdType.kMoreStep,
            ()=> {
                if (!this.isClosed)
                    this.updateAdBtn();
            });
    // });
}

CoinMatchInvitePanel.prototype.onShareInvite = function() {
    let isBusy = CoinMatchLogic.inviteShare(null, null);
}

CoinMatchInvitePanel.prototype.cleanup = function () {
    if (this.handler != null) {
        CoinMatchManager.getInstance().removeEventListener(this.handler);
        this.handler = null;
    }

    BasePanel.prototype.cleanup.call(this);
    
    if (CoinMatchConfig.moreStep.resList.length > 0)
        ResManager.release(CoinMatchConfig.moreStep.resList);
}

CoinMatchInvitePanel.prototype.buildInviteInfo = function () {
    this.createScrollView();
    this.buildInviteItems();
    this.scrollView.scrollUpdateCallback();
}

CoinMatchInvitePanel.prototype.update = function (dt) {
    if (this.isClosed){
        cc.director.getScheduler().unscheduleScriptEntry(this.schedulerId);
    }
    if (this.updateFrameIdx == 0 || this.updateFrameIdx - this.lastUpdateFrameIdx > 5){
        const col = 3
        for (var i = 0; i < 6 ; i++){
            var data = this.inviteList[this.index];
            if (data){
                let item = CoinMatchInviteItem.create(data);
                item.setAnchorPoint(-0.5, 0.5);
                this.inviteItems.push(item);
                this.scrollView.addChild(item)
                let pos = cc.p(
                    this.marginLeft * 1.5 + this.index % col * (this.inviteItemSize.width + this.marginLeft), 
                    this.firstHeight - Math.floor(this.index / col) * (this.inviteItemSize.height + this.marginDown)
                )
                item.setPosition(pos);
            }else{
                cc.director.getScheduler().unscheduleScriptEntry(this.schedulerId);
                break;
            }
            this.index += 1
        }
        this.lastUpdateFrameIdx = this.updateFrameIdx;
    }
    this.updateFrameIdx += 1;
}
CoinMatchInvitePanel.prototype.buildInviteItems = function () {
    this.updateFrameIdx = 0;
    let manager = CoinMatchManager.getInstance();
    let inviteList = manager.getInviteList();
    this.inviteList = inviteList;
    let layout = CoinMatchConfig.moreStep.scroll;
    let marginLeft = layout.marginLeft+4;
    this.marginLeft = marginLeft;
    let marginDown = layout.marginDown;
    this.marginDown = marginDown;
    let inviteItemSize = cc.size(layout.itemSize.w, layout.itemSize.h);
    this.inviteItemSize = inviteItemSize;

    this.index = 0;

    const col = 3
    let len = inviteList.length;
    const row = Math.ceil(len / 3);
    let InnerSize = cc.size(
        col * inviteItemSize.width + (col + 1) * marginLeft,
        row * (inviteItemSize.height + marginDown) - marginDown + marginDown * 4);
    this.firstHeight = InnerSize.height - marginDown * 2;
    // for (let index = 0, v = inviteList[index]; v; v = inviteList[++index]) {
    //     let item = CoinMatchInviteItem.create(v);
    //     item.setAnchorPoint(-0.5, 0.5);
    //     this.inviteItems.push(item);
    //     this.scrollView.addChild(item)
    //     let pos = cc.p(
    //         marginLeft * 1.5 + index % col * (inviteItemSize.width + marginLeft), 
    //         firstHeight - Math.floor(index / col) * (inviteItemSize.height + marginDown)
    //     )
    //     item.setPosition(pos);
    // }
    this.scrollView.setInnerContainerSize(InnerSize);

    this.schedulerId = cc.director.getScheduler().scheduleScriptFunc(handler(this, this.update), 1/60, false);
}

CoinMatchInvitePanel.prototype.createScrollView = function () {
    let layout = CoinMatchConfig.moreStep.scroll;

    let scrollViewSize = cc.size(layout.size.w, layout.size.h);
    
    let bg = GetChildByPath(this, layout.bg);
    let bgSize = bg.getContentSize();    

    this.inviteItems = [];

    let scrollView = ccui.ScrollView.create();
    scrollView.setDirection(ccui.ScrollViewDir.vertical);
    scrollView.setContentSize(scrollViewSize);
    scrollView.setClippingEnabled(false);
    scrollView.setBounceEnabled(true);
    
    let clippingNode = cc.ClippingRectangleNode.create();
    clippingNode.setClippingRegion(cc.rect(0, 0, scrollViewSize.width, scrollViewSize.height));
    clippingNode.addChild(scrollView);
    bg.addChild(clippingNode);
    this.clippingNode = clippingNode;
    this.clippingNode.setContentSize(scrollViewSize.width, scrollViewSize.height);
    this.clippingNode.setPosition((bgSize.width - scrollViewSize.width) / 2, bgSize.height - scrollViewSize.height - layout.top);

    this.scrollView = scrollView;

    let inviteItemSize = cc.size(layout.itemSize.w, layout.itemSize.h);
    let onScroll = ()=> {
        for (let index = 0, v = this.inviteItems[index]; v; v = this.inviteItems[++index]) {
            let posyTop = v.getPositionY() - inviteItemSize.height / 2
            let posyBottom = posyTop - inviteItemSize.height - 2
            let topPosInScrollView = this.scrollView.convertToNodeSpace(v.parent.convertToWorldSpace(cc.p(0, posyTop)))
            let bottomPosInScrollView = this.scrollView.convertToNodeSpace(v.parent.convertToWorldSpace(cc.p(0, posyBottom)))
            if (bottomPosInScrollView.y > scrollViewSize.width || 
                topPosInScrollView.y + inviteItemSize.height < 0) {
                v.setVisible(false)
            }else {
                v.setVisible(true)
                v.loadRes()
            }
        }
    }

    // 节流，防止太频繁的调用
    let throttleOnScroll = throttle(onScroll, 100);
    this.scrollView.addEventListener(throttleOnScroll);
    this.scrollView.scrollUpdateCallback = throttleOnScroll;
}

CoinMatchInviteItem = xClass("CoinMatchInviteItem", () => {
    return cc.CSLoader.createNode(CoinMatchConfig.moreStep.scroll.item)
})

CoinMatchInviteItem.prototype.ctor = function(data) {
    this.data = data;
}

CoinMatchInviteItem.prototype.onEnter = function() {
    cc.Node.prototype.onEnter.call(this);
    this.initUI();
    this.updateUI();
}

CoinMatchInviteItem.prototype.initUI = function () {
    let layout = CoinMatchConfig.moreStep.scroll;

    this.getBtn = GetChildByPath(this, layout.btnGet);
    quickBuildBtn(this.getBtn, UIGLabelButton, null, ()=> this.onReward(), true);

    this.inviteBtn = GetChildByPath(this, layout.btnInvite);
    quickBuildBtn(this.inviteBtn, UIButton, PushBounceAnim, ()=> this.onInvite(this.inviteBtn), true);

    this.avatar = GetChildByPath(this, layout.avatar);

    this.avatorAdd = GetChildByPath(this, layout.avatorAdd);
    quickBuildBtn(this.avatorAdd, UIButton, null, ()=> this.onInvite(this.avatorAdd), true);
    
    this.steps = GetChildByPath(this, layout.step);

    // 此处不进行分享按键展示打点，一个界面多个分享按键只打一次
    //  DCAssist.dc4ShareShow("CoinMatchAskHelp")
}

CoinMatchInviteItem.prototype.updateUI = function() {
    if (this.data.canGet == InviteRewardStatus.kCanGet) {
        this.getBtn.setVisible(true);
        this.getBtn.setString(CoinMatchConfig.strings.inviteReceive);
        this.getBtn.setEnabled(true);

        this.inviteBtn.setVisible(false);
        this.avatorAdd.setVisible(false);
    } else if (this.data.canGet == InviteRewardStatus.kRewarded) {
        this.getBtn.setVisible(true);
        this.getBtn.setString(CoinMatchConfig.strings.inviteReceived);
        this.getBtn.setEnabled(false);

        this.inviteBtn.setVisible(false);
        this.avatorAdd.setVisible(false);
    } else {
        this.getBtn.setVisible(false);
        this.inviteBtn.setVisible(true);
        this.avatorAdd.setVisible(true);
    }
    this.steps.setString(this.data.step);
}
CoinMatchInviteItem.prototype.loadRes = function() {
    if (!this.resLoaded && this.data.avatar) {
        HeadImageLoader.loadImage(this.avatar, this.data.avatar);
        this.resLoaded = true;
    }
}

CoinMatchInviteItem.prototype.onReward = function() {
    let isBusy = CoinMatchLogic.getInviteReward(
        this.data.index,
        ()=> this.updateUI(this.data));
    if (!isBusy)
        DCAssist.dc4User101("battleForGold", "click_recieveMoves_btn", { index: this.data.index });
}

CoinMatchInviteItem.prototype.onInvite = function (item) {
    // 判断点击的按钮是都在显示区域
    var anchor = item.getAnchorPoint();
    var size = item.getContentSize();
    var scale = item.scale;
    size.width = size.width * scale;
    size.height = size.height * scale;
    var clippingNode = this.getParent().getParent();
    var pos = clippingNode.convertToNodeSpace(item.convertToWorldSpace(item.getPosition()));
    var itemRect = cc.rect(pos.x - anchor.x * size.width, pos.y - anchor.y * size.height, size.width, size.height)
    var rect1 = clippingNode.getBoundingBox()
    if (cc.rectIntersectsRect(rect1, itemRect)){
        CoinMatchLogic.inviteShare();
    }
}

module.exports = CoinMatchInvitePanel